export function setVoyadoContactId(contactId: string) {
    if (typeof window.va !== 'undefined') {
        window.va('setContactId', contactId);
    }
}